import { PracticeTypeData } from "@/utils/practiceTypeData";
import { AlertTriangle, CheckCircle } from "lucide-react";

interface PracticeTypeCaseStudiesProps {
  practiceType: PracticeTypeData;
}

const PracticeTypeCaseStudies = ({ practiceType }: PracticeTypeCaseStudiesProps) => {
  return (
    <section className="py-12 sm:py-16 md:py-20">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Echte Schadensbeispiele
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-3xl mx-auto">
            Reale Fälle aus {practiceType.name.toLowerCase()} - So hat die Cyberversicherung geholfen
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {practiceType.caseStudies.map((caseStudy, index) => (
            <div
              key={index}
              className="p-8 rounded-lg bg-card border border-border hover:shadow-lg transition-all duration-300"
            >
              <h3 className="text-xl font-bold mb-4">{caseStudy.title}</h3>
              
              <p className="text-muted-foreground mb-6">
                {caseStudy.description}
              </p>

              <div className="space-y-4">
                <div className="flex gap-3">
                  <div className="flex-shrink-0 w-10 h-10 bg-red-500/10 rounded-lg flex items-center justify-center">
                    <AlertTriangle className="w-5 h-5 text-red-500" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold mb-1">Schaden</p>
                    <p className="text-sm text-muted-foreground">{caseStudy.damage}</p>
                  </div>
                </div>

                <div className="flex gap-3">
                  <div className="flex-shrink-0 w-10 h-10 bg-green-500/10 rounded-lg flex items-center justify-center">
                    <CheckCircle className="w-5 h-5 text-green-500" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold mb-1">Lösung durch Versicherung</p>
                    <p className="text-sm text-muted-foreground">{caseStudy.solution}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PracticeTypeCaseStudies;
